import { render } from "./DemoOnboardingModal.vue?vue&type=template&id=2f8802d5&scoped=true&ts=true"
import script from "./DemoOnboardingModal.vue?vue&type=script&lang=ts"
export * from "./DemoOnboardingModal.vue?vue&type=script&lang=ts"

import "./DemoOnboardingModal.vue?vue&type=style&index=0&id=2f8802d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8802d5"]])

export default __exports__